import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const taxCodes = (state = initialState.taxCodes, action) => {
  switch (action.type) {
    case types.LOAD_TAX_CODES_SUCCESS:
      return action.codes;

    default:
      return state;
  }
};
